import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MailMultipleStatutesDTO,
  MultipleStatutesDTO,
  MultipleStatutesParams,
} from 'src/app/shared/models/iCourrier/status-management/multiple-statutes';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MultipleStatutesService {
  private iCourrierURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  public getMultipleStatus(): Observable<MultipleStatutesDTO[]> {
    return this.http.get<MultipleStatutesDTO[]>(`${this.iCourrierURL}/Global/MultipleStatutes`);
  }

  public getMailMultipleStatutes(mailId: number): Observable<MailMultipleStatutesDTO[]> {
    return this.http.get<MailMultipleStatutesDTO[]>(`${this.iCourrierURL}/Mails/${mailId}/MultipleStatutes`);
  }

  public postMailMultipleStatus(mailId: number, statusIds: string): Observable<number> {
    // For the array of statusIds : it's easier to send it with a join(', ') instead of an array
    return this.http.post<number>(`${this.iCourrierURL}/Mails/${mailId}/MultipleStatutes?statusIds=${statusIds}`, null);
  }

  public deleteMailMultipleStatutes(mailId: number, statusId: number): Observable<void> {
    return this.http.delete<void>(`${this.iCourrierURL}/Mails/${mailId}/MultipleStatutes/${statusId}`);
  }

  public postManagementMultipleStatus(data: MultipleStatutesParams): Observable<MultipleStatutesDTO> {
    return this.http.post<MultipleStatutesDTO>(`${this.iCourrierURL}/Management/MultipleStatutes`, data);
  }
}
